import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Nillable } from '@web/utils';
import { AdminBannerStatusProviderService } from '../providers/admin-banner-status-provider.service';
import { AdminBannerStatus } from '../enums/admin-banner-status';

@Pipe({
  name: 'adminBannerStatus',
  standalone: true,
})
export class AdminBannerStatusPipe implements PipeTransform {
  private readonly provider = inject(AdminBannerStatusProviderService);

  public transform(status: AdminBannerStatus): Observable<Nillable<string>> {
    return this.provider.labelFor(status);
  }
}
